import { FC } from 'react';
import ProTypography, { TypographyProps } from './typography';
import ProTypographyText, { TextProps } from './text';
import ProTypographyLink, { LinkProps } from './link';
import ProTypographyTitle, { TitleProps } from './title';
import ProTypographyParagraph, { ParagraphProps } from './paragraph';

export type ITypographyComponent = FC<TypographyProps> & {
  Text: FC<TextProps>;
  Link: FC<LinkProps>;
  Title: FC<TitleProps>;
  Paragraph: FC<ParagraphProps>;
};

const TransTypography = ProTypography as ITypographyComponent;
TransTypography.Text = ProTypographyText;
TransTypography.Link = ProTypographyLink;
TransTypography.Title = ProTypographyTitle;
TransTypography.Paragraph = ProTypographyParagraph;

export default TransTypography;
